<template>
    <div>
        <app-field-toggle label="Open in new tab?" v-model="item.newTab" />
    </div>
</template>

<script>
    import TextField from '@/components/fields/inputs/Text';
    import ToggleField from '@/components/fields/inputs/Toggle';

    export default {
        props: {
            item: {
                type: Object,
                required: true
            },
            locales: {
                type: Array,
                required: true
            }
        },

        components: {
            'app-field-text': TextField,
            'app-field-toggle': ToggleField
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/menu/Page.vue